import { GetPopUpElementViewModel, PopUpElementViewModel } from '@/types/cml-api';
import { AppNextLink } from '@/features/app-next-link';
import { Button } from '@/features/button';
import CopyBox from '@/features/copy-box';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { Modal } from '@/features/modal';
import SafeHtml from '@/components/safe-html';
import { cn } from '@/utils/cn';
import { DesktopImageUrl, MobileImageUrl } from '../_utils/constants';
interface Props {
  data: PopUpElementViewModel | GetPopUpElementViewModel;
  isOpen: boolean;
  handleClose?: () => void;
  handleCopyButtonClick?: () => void;
  handleLinkButtonClick?: () => void;
  className?: string;
}
export default function PopupView({
  data,
  isOpen,
  handleClose,
  handleCopyButtonClick,
  handleLinkButtonClick,
  className
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  const mobileImageUrl = data.mobileImageUrl || MobileImageUrl;
  const desktopImageUrl = data.desktopImageUrl || DesktopImageUrl;
  return <Modal title={data.title || ''} isOpen={isOpen} handleClose={() => handleClose && handleClose()} bodyClassName='text-text-black' className={className} width='w-full lg:w-[508px]' data-sentry-element="Modal" data-sentry-component="PopupView" data-sentry-source-file="popup-view.tsx">
            <picture className={cn('my-2 block overflow-hidden rounded-sm', {
      'animate-scaling': (data as GetPopUpElementViewModel).hasDefaultPic || !data.mobileImageUrl
    })} data-sentry-element="picture" data-sentry-source-file="popup-view.tsx">
                <source media='(min-width: 1024px)' srcSet={desktopImageUrl} />

                <img src={mobileImageUrl} alt={data.title} className='w-full' />
            </picture>
            <SafeHtml content={data.description || ''} className='text-center text-body-14 lg:text-body-16' data-sentry-element="SafeHtml" data-sentry-source-file="popup-view.tsx" />
            {data.voucherCode && <>
                    <div className='my-2 text-center text-body-14 font-medium lg:text-body-16'>کد تخفیف:</div>
                    <CopyBox textCopy={data.voucherCode} className='h-10' copyButtonClassName='text-primary-main' onClick={handleCopyButtonClick} />
                </>}
            <AppNextLink href={data.link || ''} className='mt-6 block' data-sentry-element="AppNextLink" data-sentry-source-file="popup-view.tsx">
                <Button graphicStyle='filled' size={isMobile ? 'medium' : 'large'} className='w-full' onClick={handleLinkButtonClick} data-sentry-element="Button" data-sentry-source-file="popup-view.tsx">
                    {data.buttonTitle}
                </Button>
            </AppNextLink>
        </Modal>;
}